import { Component, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";

import { Profile } from "../../models/profile";

@Component({
  selector: "app-match-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule],
  templateUrl: "./match-dialog.component.html",
  styleUrl: "./match-dialog.component.scss"
})
export class MatchDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly profile: Profile,
    private readonly ref: MatDialogRef<MatchDialogComponent>,
    private readonly router: Router
  ) {}

  close(): void {
    this.ref.close();
  }

  async goToChat(): Promise<void> {
    this.ref.close();
    await this.router.navigateByUrl("/chat");
  }
}

